<template>
  <div class="flex items-center w-full bg-gray-100 rounded-lg">
    <div class="relative hidden md:inline-block text-left">
      <div>
        <button type="button" @click="toggleDropdown" class="inline-flex gap-x-1.5 justify-center px-3 py-2 w-full text-white text-sm font-semibold bg-blue-800 hover:bg-sky-600 rounded-l-md shadow-sm" id="menu-button" aria-expanded="true" aria-haspopup="true">
          {{ selectedCategory?.name || 'Categorías' }}
          <svg class="-mr-1 w-5 h-5 text-white" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
          </svg>
        </button>
      </div>

      <div v-show="isDropdownOpen" class="absolute z-10 right-0 mt-2 w-56 bg-white rounded-md focus:outline-none shadow-lg origin-top-right ring-1 ring-black ring-opacity-5" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
        <div class="py-1" role="none">
          <a href="#" @click.prevent="selectCategory(category)" v-for="(category, index) in categories" :key="index" class="block px-4 py-2 text-gray-700 text-sm" role="menuitem" tabindex="-1">
            {{ category.name }}
          </a>
        </div>
      </div>
    </div>

    <div class="relative ml-2 w-full">
      <input type="text" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" @keyup.enter="performSearch" placeholder="¿Qué estás buscando?" class="pr-10 px-4 py-2 w-full bg-gray-100 rounded-lg" />
      <div class="absolute inset-y-0 right-0 flex items-center pl-3 pointer-events-none">
        <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
        </svg>
      </div>
    </div>
    <!-- <button @click="performSearch" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg ml-2">
        Buscar
      </button> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchQuery: '',
      selectedCategory: null,
      isDropdownOpen: false,
    }
  },
  props: {
    categories: Object,
    modelValue: String,
    maxWidth: {
      type: Number,
      default: 300,
    },
  },
  emits: ['update:modelValue', 'reset'],
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen
    },
    selectCategory(category) {
      this.$emit('category', category)
      this.selectedCategory = category
      this.isDropdownOpen = false
    },
    performSearch() {
      // Aquí puedes emitir un evento con la query y la categoría seleccionada
      this.$emit('search', this.searchQuery, this.selectedCategory)
      console.log('Buscar:', this.searchQuery, this.selectedCategory)
    },
  },
}
</script>
